import { createContext, useContext, useEffect, useState } from "react";
import { CalendarDays } from "lucide-react";
import { api } from "@/lib/api";
import { EVENT_SCOPE_KEY, getEventId, eventDisplayName } from "@/lib/eventScope";

const EventContext = createContext(null);
export const EventProvider = ({ children }) => {
    const [eventId, setId] = useState(getEventId);
    const [events, setEvents] = useState([]);
    const [publicId, setPublicId] = useState(null);
    const select = id => { localStorage.setItem(EVENT_SCOPE_KEY, id); setId(id); };
    const current = events.find(e => e.id === eventId);
    const eventLabel = eventId === "tutti" ? "Tutti gli eventi / Generale" : eventDisplayName(current) || "Evento selezionato";
    return <EventContext.Provider value={{ eventId, eventLabel, events, setEvents, publicId, setPublicId, select }}>{children}</EventContext.Provider>;
};
export const useEventScope = () => useContext(EventContext);

export const EventScopeBar = ({ token, prefix = "admin" }) => {
    const { eventId, eventLabel, events, setEvents, publicId, setPublicId, select } = useEventScope();
    const [error, setError] = useState("");
    useEffect(() => {
        if (!token) return;
        api.get("/admin/events", { headers: { "x-admin-token": token } }).then(({ data }) => {
            setEvents(data.events); setPublicId(data.public_event_id);
            if (eventId !== "tutti" && !data.events.some(e => e.id === eventId)) select(data.legacy_event_id);
        }).catch(() => setError("Elenco eventi non disponibile"));
        // Registry is shared; selecting an event must not refetch it or reset the current tab.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);
    return <div className="border-y border-[#9AA2AD]/25 py-4 mb-6 flex flex-wrap items-center gap-3" data-testid={`${prefix}-event-context`}>
        <CalendarDays size={18} className="text-[#E2231A] shrink-0" />
        <label className="text-xs text-[#9AA2AD]" htmlFor={`${prefix}-event-select`}>Evento attivo</label>
        <select id={`${prefix}-event-select`} data-testid={`${prefix}-event-select`} value={eventId} onChange={e => select(e.target.value)} className="bg-[#0B0D10] border border-[#9AA2AD]/30 px-3 py-2 text-sm max-w-full min-w-0 flex-1 sm:flex-none sm:min-w-[290px]">
            <option value="tutti">Tutti gli eventi / Generale</option>
            {!events.length && eventId !== "tutti" && <option value={eventId}>Caricamento…</option>}
            {events.map(e => <option key={e.id} value={e.id} data-testid={`${prefix}-event-option-${e.id}`}>{`${eventDisplayName(e)} · ${e.data.split("-").reverse().join("/")} · ${e.stato}`}</option>)}
        </select>
        <span className="text-xs text-[#9AA2AD]" data-testid={`${prefix}-event-caption`}>{eventLabel}</span>
        {publicId && <span className="text-[11px] text-emerald-300 sm:ml-auto" data-testid={`${prefix}-public-event`}>Sito: {eventDisplayName(events.find(e => e.id === publicId))}</span>}
        {error && <span role="alert" data-testid={`${prefix}-events-error`} className="text-xs text-red-400">{error}</span>}
    </div>;
};